module.exports = __webpack_public_path__ + "static/media/profile-dark-avatar.28ebd806.png";